import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import {
  FlexCol,
  FlexRowCenterVertical,
  FlexColCenter,
} from '../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../Defaults/Text';
import { __ } from 'react-i18n';
import {
  formatPriceToString,
  prop,
  round,
  formatPrice,
} from '../../../utilities';

interface Props {
  text: string;
  isMobile?: boolean;
  notAbsolute?: boolean;
  style?: any;
}

function SaleBubble({ text, isMobile, notAbsolute, style }: Props) {
  let correctDiscount;
  if (text.includes('%')) {
    correctDiscount = text;
  } else {
    correctDiscount = round(parseFloat(text), 2);
  }

  return (
    <Wrapper style={style} notAbsolute={notAbsolute} isMobile={isMobile}>
      {correctDiscount}
    </Wrapper>
  );
}

const Wrapper = styled(FlexColCenter)<{
  isMobile?: boolean;
  notAbsolute?: boolean;
}>`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  width: ${rem(70)};
  height: ${rem(70)};
  border-radius: 50%;
  position: ${({ notAbsolute }) => (notAbsolute ? 'initial' : 'absolute')};
  top: ${({ isMobile }) => (isMobile ? rem(-24) : rem(-24))};
  right: ${({ isMobile }) => (isMobile ? 0 : rem(-24))};
  cursor: initial;

  ${({ theme }) => theme.mediab.m760`
  `}
`;

export { SaleBubble };
